// The Pricing tab's signed euro input, so a preset reads like the row it fills.
const amountInputProps = {
  type: 'number',
  step: '0.01',
  placeholder: '0',
  prefixElement: <span className="pr-2">€</span>,
  onWheel: (e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur(),
} as const;

export { amountInputProps };
